<template>
  <a-modal
      :title="$t('message.customGroup.SaveAudience')"
      :okText="$t('message.commonUsage.save')"
      :cancelText="$t('message.commonUsage.cancel')"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submit"
      @cancel="visible = false"
      :afterClose="afterClose"
  >
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('message.customGroup.UserCount')">
        {{ form.info_val_list.length }}
      </a-form-model-item>
      <a-form-model-item :label="$t('message.customGroup.CalculationType')" prop="calc_type">
        <a-radio-group :size="$globalSize" v-model="form.calc_type" disabled>
          <a-radio :value="1">
            {{$t('message.customGroup.Dynamic')}}
          </a-radio>
          <a-radio :value="2">
            {{$t('message.customGroup.Static')}}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('message.customGroup.title4')" prop="group_name">
        <a-input :size="$globalSize" v-model="form.group_name"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('message.customGroup.AudienceIDGenerate')" prop="if_auto">
        <a-radio-group :size="$globalSize" v-model="form.if_auto" @change="form.group_id = undefined">
          <a-radio :value="0" disabled>
            {{$t('message.customGroup.Manually')}}
          </a-radio>
          <a-radio :value="1">
            {{$t('message.customGroup.Autogen')}}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('message.customGroup.title5')" prop="group_id" v-if="!form.if_auto">
        <a-input-number :size="$globalSize" v-model="form.group_id" :min="0"
                 :max="9007199254740992"
                 :step="1"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import utils from "@/utils";
import userGroupListService from "@/interface/pages/UserGroup/userList";

export default {
  name: "saveUserGroupModal",
  components: {},
  props: {},

  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 6 : 10
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 14
      },
      form: {
        info_type:'',
        calc_type: 2,
        if_auto: 1,
        info_val_list: [],
        group_id:undefined,
        group_name:undefined
      },
      rules: {
        calc_type: [{required: true, message: this.$t('message.customGroup.SelectCalculationType'),trigger: 'change'}],
        if_auto: [{required: true, message: '请选择生成方式', trigger: 'change'}],
        group_name: [{required: true, message: this.$t('message.uploadGroup.title10'), trigger: 'change'}],
        group_id: [{required: true, message: this.$t('message.uploadGroup.title8'), trigger: 'blur'}],
      },
    };
  },
  mounted() {
    utils.languageChange(this, {labelCol: 8, wrapperCol: 16}, {labelCol: 6, wrapperCol: 16})
  },
  computed: {},
  watch: {},
  methods: {
    showModal(result,type) {
    
      this.form.info_val_list = [...result.map(String)]
      this.form.info_type = type
      this.visible = true;
    },
    submit() {
      this.$refs.ruleForm.validate(async valid=>{
        if(!valid)return false
        this.confirmLoading = true
        const {data: res} = await userGroupListService.uploadUserGroup(this, {data: {...this.form,loginId:localStorage.getItem('userId')}})
        try {
          if (res.code === '200') {
            this.$message.success(res.message)
            this.visible = false;
            this.$store.dispatch('fetchButtonPermission')
            this.$router.push({name: 'userGroupList'})
          } else {
            this.$message.error(res.message)
          }
          this.confirmLoading = false
        } catch (e) {
          console.log(e)
          this.confirmLoading = false
        }
      })

    },
    afterClose() {
    }
  },
};
</script>

<style scoped lang="less">

</style>
